import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartItem {
  currency: string;
  id: string;
  title: string;
  price: string;
  quantity: number;
  image: string;
  product_url: string;
  taxesAndCharges:string;
  
}

interface CartState {
  items: CartItem[];
  selectedCustomer: string;
}

const initialState: CartState = {
  items: [],
  selectedCustomer: 'walking-customer',
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      const existingItem = state.items.find(item => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
    },
    removeFromCart: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    clearCart: (state) => {
      state.items = [];
    },
    updateQuantity: (state, action: PayloadAction<{ id: string; quantity: number }>) => {
      const item = state.items.find(item => item.id === action.payload.id);
      if (item) {
        item.quantity = action.payload.quantity;
      }
    },
    setSelectedCustomer: (state, action: PayloadAction<string>) => {
      state.selectedCustomer = action.payload;
    },
  },
});

export const { 
  addToCart, 
  removeFromCart, 
  clearCart, 
  updateQuantity,
  setSelectedCustomer 
} = cartSlice.actions;

export default cartSlice.reducer;